import { useIsMounted } from 'hooks/useIsMounted';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { getAssetThumbnailInline } from 'service/storage';
import { selectDownloadedThumbnail } from 'store/sync/selectors';

type ThumbnailProps = {
  image: string;
};

export const useGetThumbnail = (
  thumbnailId: string,
): ThumbnailProps | undefined => {
  const [thumbnail, setThumbnail] = React.useState<ThumbnailProps | undefined>(
    undefined,
  );
  const downloadedThumbnail = useSelector((state) =>
    selectDownloadedThumbnail(state, thumbnailId),
  );
  const isMounted = useIsMounted();

  React.useEffect(() => {
    async function getThumbnail(data: string | { assetId: string }) {
      requestAnimationFrame(async () => {
        try {
          const { assetId } =
            typeof data === 'string' ? { assetId: data } : data;
          const storageThumbnail = await getAssetThumbnailInline(
            assetId,
            thumbnailId,
          );
          if (isMounted.current) {
            setThumbnail({
              image: storageThumbnail,
            });
          }
        } catch (_) {
          if (isMounted.current) {
            setThumbnail(undefined);
          }
        }
      });
    }
    if (isMounted.current) {
      if (thumbnailId && downloadedThumbnail !== undefined) {
        getThumbnail(downloadedThumbnail);
      } else {
        setThumbnail(undefined);
      }
    }
  }, [thumbnailId, downloadedThumbnail, isMounted]);

  return thumbnail;
};
